module.exports = __webpack_public_path__ + "media/images/pic/saska/cambridge_bg-98645bf5929ab5e866026245bcaba3cf.png";